export default __webpack_public_path__ + "static/media/CapresePizza.a85687b0.jpg";